import c from '../common';

export default{
    "description_phone": "電話︰",
    "description_Prule1": "請輸入電話",
    "description_Prule2": "電話只可包含數字",
    "description_Prule3": "不可含有空格",

    "Password": "密碼︰",
    "Pw_requirement": "請輸入9至16位密碼",

    "Wrong-index-1": "帳號或登入密碼錯誤,請重新輸入",
    "re-enter": "重新輸入",

    "NA1": "帳戶不適用於此平台",

    "Login": "登入",
    "Register": "註冊",
    "Forgot": "忘記密碼",

    "V-Code": c.V_Code.chn,

    "PinWrong": "驗證碼不正確",

    "back": c.Back.chn,
    "confirm": c.Confirm.chn,

    "6digit": "請輸入6位數字",
    "Only6": "只可包含數字",

    "description_1": c.BBS_title.chn,
    "description_2": "手機號碼無效",
    
};